import { FolderScopesState } from '../models'
import { folderScopesColumnsBaseConfig } from './folder-details-table'

export const folderScopesInitialState: FolderScopesState = {
  isLoadingTable: false,
  columns: folderScopesColumnsBaseConfig,
  scopeDetails: {},
}
